import { cn } from "../lib/utils";

interface LogoMarkProps {
  className?: string;
  compact?: boolean;
  inverse?: boolean;
}

export function LogoMark({
  className,
  compact = false,
  inverse = false,
}: LogoMarkProps) {
  return (
    <div className={cn("inline-flex items-center gap-3", className)}>
      <span
        aria-hidden="true"
        className={cn(
          "relative grid size-9 shrink-0 place-items-center rounded-xl bg-accent font-black text-sidebar shadow-[0_8px_22px_-10px_rgba(255,118,87,0.8)]",
          compact && "size-8 rounded-[0.65rem] text-sm",
        )}
      >
        T
        <span className="absolute top-1.5 right-1.5 text-[0.52rem] leading-none">
          2
        </span>
      </span>
      {!compact && (
        <span
          className={cn(
            "text-lg font-extrabold tracking-[-0.04em]",
            inverse ? "text-white" : "text-ink",
          )}
        >
          tax2
        </span>
      )}
      <span className="sr-only">Tax2</span>
    </div>
  );
}
